import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { Button, ButtonText } from "ui/gluestack/button";
import { RenderInfoItem } from "ui/molecules/common/RenderInfoItem";
import StatusIndicator from "ui/atoms/avatar/statusIndicator/StatusIndicator";
import { StatusIndicatorMapping } from "../../../services/api/types/residents/enums/ResidentStatusEnum";
import { AdministerSkipMedicationList } from "../organisms/AdministerSkipMedicationList";
import { useResidentMedicationsContext } from "../provider/ResidentMedicationsProvider";
import { Avatar } from "ui/atoms/avatar";
import { Portal } from "ui/modules/ThrelsPortal/Portal";
import { useAdministerBulkMedicationsContext } from "../provider/AdministerBulkMedicationsProvider";

interface Props {
  onClose: () => void;
}

export default function AdministerBulkMedicationFormTemplate({
  onClose,
}: Props) {
  const { residentInfo } = useResidentMedicationsContext();
  const { administerBulkMedication, isSubmitting } =
    useAdministerBulkMedicationsContext();

  return (
    <View>
      <View className="flex flex-row border p-4 mt-2 border-gray-200 rounded-lg">
        <View>
          <Avatar
            image={residentInfo.profile ?? undefined}
            profile={residentInfo}
            size="md"
          ></Avatar>
        </View>
        <View className="ml-10 gap-2">
          <Text className="text-xl font-semibold">
            {residentInfo.name}
            {residentInfo.nickname ? `(${residentInfo.nickname})` : null}
          </Text>
          <View className="flex flex-row gap-x-2 text-typography-600">
            {RenderInfoItem(residentInfo.roomNumber, false)}
            {RenderInfoItem(residentInfo.bedNumber, false)}
            {RenderInfoItem(`Admitted - ${residentInfo.admittedDate}`, true)}
          </View>
          {residentInfo.status ? (
            <StatusIndicator
              status={StatusIndicatorMapping[residentInfo.status]}
              statusTitle={residentInfo.status}
            />
          ) : null}
        </View>
      </View>

      <View className="py-10">
        <AdministerSkipMedicationList />
      </View>

      <Portal hostName="modal-footer" identifier="bulk-meds">
        <View className="flex flex-row justify-end gap-x-4 pt-2 px-10">
          <Button
            action="primary"
            size="sm"
            variant="outline"
            onPress={onClose}
          >
            <ButtonText>Cancel</ButtonText>
          </Button>
          <Button
            action="primary"
            size="sm"
            onPress={administerBulkMedication}
            disabled={isSubmitting}
          >
            <ButtonText className="text-white">Log</ButtonText>
          </Button>
        </View>
      </Portal>
    </View>
  );
}
